import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/payroll/periods',
}).lazy(() => import('./periods.index.lazy').then((d) => d.Route))
